<template>
  <div
    :class="`modal fade px-0 ${$props.value ? 'show d-block' : 'd-none'}`"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header d-flex align-items-center">
          <h4 class="modal-title text-left">
            Location History
          </h4>
          <button
            type="button"
            class="close"
            @click="close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body container-fluid">
          <ul
            v-if="entries.length > 0"
            class="list-group mb-2"
          >
            <li
              v-for="(e, i) in entries"
              class="list-group-item"
              :key="i"
            >
              <p class="m-0">
                {{ new Date( e.createdAt ).toLocaleString() }} | User: {{ e.userID }}
              </p>
              <label class="mb-0 mt-2">Before:</label>
              <textarea
                class="form-control mb-2 w-100"
                readonly
                rows="2"
                :value="JSON.stringify(e.before)"
              />
              <label class="mb-0">After:</label>
              <textarea
                class="form-control w-100"
                readonly
                rows="2"
                :value="JSON.stringify(e.after)"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import notify from '../../notifications';
import http from '../../http';

export default {
    data() {
        return {
            entries: [],
            children: {},
            loading: false,
            loaded: false
        };
    },
    methods: {
        close() {
            this.$emit( 'input', false );
        },
        async fetchHistory() {
            this.loading = true;

            const params = new URLSearchParams();
            params.set( 'take', '10' );
            params.set( 'skip', '0' );

            const response = await http.get( `/locations/${this.$props.locationId}/history?${params.toString()}` );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    title: 'Failed to load location by ID'
                } );
                return;
            }

            const result = await response.json();

            if ( result.entries ) {
                this.entries = [
                    ...this.entries,
                    ...result.entries
                ];
            }

            this.loading = false;
            this.loaded = true;
        }
    },
    async updated() {
        if ( !this.loaded && this.$props.locationId && this.$props.value ) {
            await this.fetchHistory();
        }
    },
    props: {
        value: {
            type: Boolean,
            required: true,
            default: () => false
        },
        locationId: {
            type: Number,
            required: true,
            default: () => 0
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/locations/LocationHistoryModal.vue